import { Component, OnInit, ViewChild } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'
import { IClaimLineView, ClaimLineViewODataService } from '@exchange/domain/.'
import { GridWrapperComponent, SingleRowSelection } from 'common-components'

@Component({
  selector: 'app-remit-list-match-claim-modal',
  templateUrl: './remit-list-match-claim-modal.component.html',
  standalone: false
})
export class RemitListMatchClaimModalComponent implements OnInit {
  @ViewChild('remittanceClaimLinesGrid', { static: true })
  remittanceClaimLinesGrid: GridWrapperComponent
  selectedClaimLine: IClaimLineView
  hasSelection: boolean
  onClose: Subject<any>

  constructor(
    public modalRef: BsModalRef,
    private claimLineViewService: ClaimLineViewODataService
  ) {}

  public ngOnInit(): void {
    this.onClose = new Subject<any>()
    this.initRemittanceClaimLinesGrid()
  }

  matchClaim(val: boolean): void {
    this.modalRef.hide()
    this.onClose.next(val ? this.selectedClaimLine : false)
    this.onClose.complete()
  }

  gridSelectionChanged() {
    const rows = this.remittanceClaimLinesGrid.api.getSelectedRows()
    this.hasSelection = !!rows.length
    this.selectedClaimLine = null
    if (this.hasSelection) {
      this.selectedClaimLine = rows[0] as IClaimLineView
    }
  }

  initRemittanceClaimLinesGrid() {
    this.remittanceClaimLinesGrid.gridOptions.columnDefs = [
      {
        headerName: 'CHI Clm ID',
        field: 'ClaimId',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 70,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Provider Clm ID',
        field: 'Identifier',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 70,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Ln',
        field: 'ServiceLineId',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 50
      },
      {
        headerName: 'Billed Amount',
        field: 'BilledAmount',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 130,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'PX Code',
        field: 'ProcedureCode',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 80,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      // TODO: MODIFIER
      {
        headerName: 'Provider',
        field: 'ProviderName',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Processing Status',
        field: 'Status',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 130,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      }
    ]
    this.remittanceClaimLinesGrid.odata = this.claimLineViewService
    this.remittanceClaimLinesGrid.gridOptions.suppressColumnVirtualisation = true
    this.remittanceClaimLinesGrid.gridOptions.rowSelection = SingleRowSelection
    this.remittanceClaimLinesGrid.gridOptions.onSelectionChanged = this.gridSelectionChanged.bind(
      this
    )
  }
}
